"use client";

import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const projects = [{
  id: 1,
  image: "https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi9.jpg",
  caption: "Structural Steel Bridge Installation"
}, {
  id: 2,
  image: "https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi3.jpg",
  caption: "Custom Metal Railing Fabrication"
}, {
  id: 3,
  image: "https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi6.jpg",
  caption: "Industrial Welding Framework"
}, {
  id: 4,
  image: "https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi4-e1762261855543.jpg",
  caption: "Commercial Steel Beam Assembly"
}, {
  id: 5,
  image: "https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi1-e1762262198151.jpg",
  caption: "Decorative Metal Gate Design"
}];
export default function CustomMetalCreations() {
  return <section className="bg-background py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground text-center mb-12">
          Custom Metal Creations
        </h2>
        
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {projects.map((project, i) => <CarouselItem key={project.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <Card className="group overflow-hidden transition-all duration-300 ease-[var(--ease-out-back)] hover:shadow-strong">
                  <div className="relative overflow-hidden">
                    <img src={project.image} alt={project.caption} className="w-full h-64 object-cover transition-transform duration-300 ease-[var(--ease-out-back)] group-hover:scale-[1.03]" />
                  </div>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="left-4 md:left-8" aria-label="View previous project" />
          <CarouselNext className="right-4 md:right-8" aria-label="View next project" />
        </Carousel>
      </div>
    </section>;
}